var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrilliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.5517C13 25.5517 13 13 22.4138 13C13 13 13 0.448276 13 0.448276C13 0.448276 13 13 3.58621 13C13 13 13 25.5517 13 25.5517ZM22.4138 10.7586C22.4138 10.7586 22.4138 5.37931 26 5.37931C22.4138 5.37931 22.4138 0 22.4138 0C22.4138 0 22.4138 5.37931 18.8276 5.37931C22.4138 5.37931 22.4138 10.7586 22.4138 10.7586ZM3.58621 26C3.58621 26 3.58621 20.6207 7.17241 20.6207C3.58621 20.6207 3.58621 15.2414 3.58621 15.2414C3.58621 15.2414 3.58621 20.6207 0 20.6207C3.58621 20.6207 3.58621 26 3.58621 26Z",
    fill: "#0F0C0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrilliance);
export default __webpack_public_path__ + "static/media/Brilliance.f05431cdf1c7c84495fa85eb5328894e.svg";
export { ForwardRef as ReactComponent };